<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.2427 40C30.9091 40 30.582 39.9034 30.2976 39.7209L19.9997 33.2263L9.69852
        39.7226C9.39265 39.9154 9.0392 40.0094 8.68249 39.9929C8.32578 39.9763 7.98167
        39.85 7.69331 39.6296C7.40495 39.4092 7.18516 39.1046 7.06151 38.7541C6.93785
        38.4035 6.91583 38.0226 6.9982 37.659L9.71686 25.4078L0.624123 17.1618C0.354792
        16.9167 0.160479 16.594 0.0654803 16.2339C-0.0295182 15.8738 -0.0209857 15.4925
        0.0900107 15.1375C0.201007 14.7825 0.409542 14.4696 0.689538 14.238C0.969535
        14.0063 1.30857 13.8662 1.66425 13.8352L13.6456 12.7519L18.3329 1.16005C18.4703
        0.816156 18.702 0.522511 18.9986 0.316087C19.2952 0.109662 19.6435 -0.000315226
        19.9997 6.78658e-07C20.3558 0.000370269 20.7038 0.110622 21.0003 0.316962C21.2968
        0.523301 21.5286 0.816563 21.6666 1.16005L26.3538 12.7519L38.3352 13.8352C38.6926
        13.867 39.0329 14.009 39.3132 14.243C39.5936 14.4771 39.8014 14.7929 39.9104
        15.1505C40.0221 15.5052 40.0295 15.8868 39.9318 16.246C39.834 16.6052 39.6355
        16.9254 39.362 17.1653L30.2859 25.4078L33.0013 37.6642C33.0644 37.9427 33.0664
        38.2325 33.0074 38.512C32.9483 38.7915 32.8296 39.0534 32.6601 39.278C32.4906
        39.5027 32.2748 39.6843 32.0288 39.8094C31.7827 39.9344 31.5162 39.9996 31.2427
        40Z"
    />
  </svg>
</template>
